import InviteStaffToSolveContainer from './invite_staff_to_solve_container';

const InviteStaffToSolve = InviteStaffToSolveContainer;
export default InviteStaffToSolve;
